const locale = {
  placeholder: 'Valitse aika',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/fi_FI.tsx